<template>
  <v-container fluid class="px-0">
    <v-card class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4">
            Paieška
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="3">
              <el-text-field
                label="Registracijos numeris"
                v-model="mainData.zug_numeris"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-text-field
                label="Identifikavimo kodas (IDK)"
                v-model="mainData.zug_identifikavimo_kodas"
                idk
                hide-details
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-text-field
                label="Duomenų teikėjo dokumento numeris"
                v-model="mainData.zug_dokumento_numeris"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-autocomplete
                :items="busena_objektas"
                itemvalue="value"
                itemtext="text"
                :multiple="true"
                label="Būsena"
                v-model="mainData.zug_busena"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-checkbox
                class="mt-2 mb-2 ml-0"
                label="Mano darbai"
                v-model="mainData.mano_darbai"
              />
            </v-col>
          </v-row>

          <v-expansion-panels
            v-model="searchPanel"
            :class="isExpanded ? `mb-4` : `mb-4 mt-3`"
            :flat="isExpanded"
          >
            <v-expansion-panel>
              <v-expansion-panel-header :class="isExpanded ? `pa-0` : ``">
                <v-row no-gutters>
                  <v-col cols="4">
                    Išplėstinė paieška
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="expansion-panel-no-padding">
                <v-row>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="objektasList"
                      itemvalue="value"
                      itemtext="text"
                      :multiple="false"
                      label="Objektas"
                      v-model="extraData.objektas"
                      @change="objektasChange()"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="veiksmasList"
                      itemvalue="value"
                      itemtext="text"
                      :multiple="true"
                      label="Objekto veiksmas"
                      :readonly="!enableVeiksmas"
                      v-model="extraData.veiksmas"
                      @change="veiksmasChange()"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="objRusisList"
                      itemvalue="value"
                      itemtext="text"
                      :multiple="true"
                      label="Hipotekos/įkeitimo rūšis"
                      v-model="objRusis"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="turtasRusisList"
                      itemvalue="value"
                      itemtext="text"
                      label="Turto rūšis"
                      v-model="mainData.tur_rusis"
                      @change="turtasChange()"
                    />
                  </v-col>
                  <template v-if="mainData.tur_rusis">
                    <v-col cols="12" md="4" v-if="search1 !== null">
                      <el-text-field
                        :key="search1Key"
                        :label="search1"
                        v-mask="mask1"
                        :placeholder="placeholder1"
                        v-model="mainData[search1Field]"
                      />
                    </v-col>
                    <v-col cols="12" md="4" v-if="search2 !== null">
                      <el-text-field
                        :key="search2Key"
                        :label="search2"
                        v-model="mainData[search2Field]"
                      />
                    </v-col>
                  </template>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="filteredPranesimasRusys"
                      itemvalue="value"
                      itemtext="text"
                      :multiple="true"
                      label="Pranešimo rūšis"
                      v-model="pranesimasRusis"
                      @change="changePranesimasRusis()"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="pranesimasRusisVeiksmai"
                      itemvalue="value"
                      itemtext="text"
                      label="Pranešimo veiksmas"
                      v-model="extraData.obj_veiksmas"
                      @change="changePranesimasRusis()"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="vietaList"
                      itemvalue="value"
                      itemtext="text"
                      label="Rengimo vieta"
                      v-model="extraData.obj_sistema"
                    />
                  </v-col>
                  <v-col cols="12" md="12">
                    <el-autocomplete
                      :items="hipoteka_rusys"
                      itemvalue="value"
                      itemtext="text"
                      :multiple="true"
                      label="Pranešimo Hipotekos registrui rūšis"
                      v-model="hipotekaRusis"
                      @change="changeHipotekaRusis()"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-date-picker
                      label="Gavimo data nuo"
                      v-model="extraData.zug_gavimo_data_nuo"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-date-picker
                      label="Gavimo data iki"
                      v-model="extraData.zug_gavimo_data_iki"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-date-picker
                      label="Būsenos data nuo"
                      v-model="extraData.zug_busenos_data_nuo"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-date-picker
                      label="Būsenos data iki"
                      v-model="extraData.zug_busenos_data_iki"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-text-field
                      label="Paskutinis veiksmus atlikęs asmuo"
                      v-model="extraData.zug_atnaujino"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-text-field
                      label="Duomenų teikėjas"
                      v-model="extraData.zug_duomenu_teikejas"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-text-field
                      label="Vykdytojas"
                      v-model="extraData.zug_vykdytojas"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <el-text-field
                      label="Užsakymo PAS Nr."
                      v-model="extraData.uzs_paslaugos_pra_id"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                :loading="loading"
                primary
                @click.native.stop="searchData()"
              >
                Ieškoti
              </el-button>
              <el-button :loading="loading" @click.native="clearData()">
                Išvalyti
              </el-button>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import objektasSearch from '../../mixins/objektasSearch'
import paieskaTurtasTipai from '../paieska/paieskaTurtasTipai'

export default {
  name: 'ZurnalasGaunamiSearch',
  props: {
    loading: Boolean,
  },
  mixins: [objektasSearch, paieskaTurtasTipai],
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {
      mano_darbai: true,
      tur_rusis: null,
    },
    extraData: {
      objektas: null,
      veiksmas: [],
      rusys: {},
    },
    pranesimas_rusys: [],
    hipoteka_rusys: [],
    pranesimasRusis: [],
    hipotekaRusis: [],
    objRusis: [],
    busena_objektas: [],
  }),
  computed: {
    ...mapGetters(['searchParams', 'listInfo']),
    isExpanded() {
      return this.searchPanel === 0
    },
    objRusisList() {
      return [
        {
          value: 'maksimalus',
          text: 'Maksimalioji',
        },
        {
          value: 'paprastas',
          text: 'Paprastoji',
        },
        {
          value: 'jungtinis',
          text: 'Jungtinė',
        },
        {
          value: 'svetimas',
          text: 'Svetimo daikto',
        },
        {
          value: 'bendras',
          text: 'Bendroji',
        },
        {
          value: 'imones',
          text: 'Įmonės',
        },
        {
          value: 'salyginis',
          text: 'Sąlyginė',
        },
        {
          value: 'pareikstinis',
          text: 'Pareikštinė',
        },
      ]
    },
    vietaList() {
      return [
        {
          text: 'Darbo vieta',
          value: 1,
        },
        {
          text: 'Savitarna',
          value: 2,
        },
      ]
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: [
          'perduoti_rusys',
          'zurnalas_gaunami_hipoteka_rusys',
          'busena_objektas',
        ],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pranesimas_rusys = res.data.list.perduoti_rusys
          this.hipoteka_rusys = res.data.list.zurnalas_gaunami_hipoteka_rusys
          this.busena_objektas = res.data.list.busena_objektas
          this.mainData.zug_busena = ['perduotas', 'nepatikslintas']
          this.mainData.mano_darbai = !this.roleOr([
            'RG_NTR_vadovas',
            'SK_skaitytojas',
          ])

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      this.extraData.rusys = {}
      this.objRusis.forEach(item => {
        this.extraData.rusys[item] = true
      })

      let searchData = {
        ...this.mainData,
        ...this.extraData,
        pranesimasRusis: this.pranesimasRusis,
        hipotekaRusis: this.hipotekaRusis,
        objRusis: this.objRusis,
      }

      if (this.$route.params.toList) {
        searchData = this.listInfo.search
        this.pranesimasRusis = this.listInfo.search.pranesimasRusis
        this.hipotekaRusis = this.listInfo.search.hipotekaRusis
        this.objRusis = this.listInfo.search.objRusis
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
        rusys: {},
      }
      this.pranesimasRusis = []
      this.hipotekaRusis = []
      this.objRusis = []
    },
    submit() {
      this.searchData()
    },
    changePranesimasRusis() {
      this.extraData.zug_obj_tipas = this.pranesimasRusis
      this.hipotekaRusis = []
    },
    changeHipotekaRusis() {
      this.extraData.zug_obj_tipas = this.hipotekaRusis
      this.pranesimasRusis = []
      this.extraData.obj_veiksmas = null
    },
    clearRusis() {
      this.extraData.zug_obj_tipas = []
      this.pranesimasRusis = []
      this.hipotekaRusis = []
    },
    turtasChange() {
      this.mainData.tur_identifikatorius = null
      this.mainData.tur_orlaivis_registracijos_zenklas = null
      this.mainData.tur_ktp_valstybinis_numeris = null
      this.mainData.tur_ginklas_numeris = null
      this.mainData.tur_juru_laivas_registracijos_numeris = null
      this.mainData.tur_ntr_registras = null
    },
  },
}
</script>
